module.exports = __webpack_public_path__ + "static/media/result_rc_ja.c16786e3.jpg";